import { Suspense } from "react";
import { lazyImport } from "../utils/lazyImport";
import LiveMain from "../modules/live-main";
import Registration from "../modules/auth/Registration";
import { Navigate } from "react-router-dom";
import LiveEnd from "../modules/live-end";
import LiveEndAttendee from "../modules/live-end/index_attendee";
import Login from "../modules/auth/Login";

// const { Dashboard } = lazyImport(() => import('@/features/misc'), 'Dashboard');

export const protectedRoutes = [
  {
    path: "/",
    element: <Navigate to='/stream/:id'/> ,
    
  },
  {
    path: "/:id",
    element: <Registration />,
    
  },
  {
    path: "/:id/login",
    element: <Registration />,
    
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/stream/:id",
    element: <LiveMain />,
  },
  {
    path: "/stream",
    element: <LiveMain />,
  },
  {
    path :"/endLive",
    element:<LiveEnd/>,
    
  },
  {
    path :"/endLiveAttendee",
    element:<LiveEndAttendee/>,
    
  },
];
